/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'medical doc': {
    width: 16,
    height: 16,
    viewBox: '0 0 51.27 65.44',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M.22 14V5.39A5.17 5.17 0 0 1 5.39.22h33.23M51.05 12.55v47.51a5.17 5.17 0 0 1-5.17 5.17H5.39a5.17 5.17 0 0 1-5.17-5.17v-36"/><path pid="1" class="cls-2" d="M51.05 12.56h-7.26a5.17 5.17 0 0 1-5.17-5.17V.22z"/><path pid="2" class="cls-3" d="M8.78 31.1h5.36l3.77-7.56L22.31 35l5.08-19.91L33.56 41l3-10h5.9"/><path pid="3" class="cls-1" d="M8.64 48.45h34.01M8.63 56.34h34.01"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/medical doc.js